export default function Loading({ showLoading = false }: { showLoading?: boolean }) {
  return (
    <div className="absolute top-0 left-0 w-full">
      <div
        style={{ display: showLoading ? "block" : "none" }}
        className="h-[3px] w-full overflow-hidden bg-[var(--surface-primary-fixed-default)]/20"
        id="loading_progress_bar"
        tabIndex={10}
        aria-label="Por favor aguarde..."
        aria-live="assertive"
        role="alert"
      >
        <div className="h-full w-1/3 animate-indeterminate bg-[var(--surface-primary-fixed-default)]" />
      </div>
    </div>
  );
}